const items = [
  "No puzzles",
  "No shortcuts",
  "Snooze won't save you",
  "Just walk",
  "Walk to wake up",
];

export const Marquee = () => {
  const row = [...items, ...items, ...items];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative overflow-hidden border-y border-line bg-sand/60 py-5"
    >
      <div className="marquee-track flex w-max items-center whitespace-nowrap">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center">
            {row.map((item, i) => (
              <span key={`${half}-${i}`} className="flex items-center">
                <span className="font-serif text-xl italic text-ink/80 sm:text-2xl">
                  {item}
                </span>
                <span className="mx-8 h-1.5 w-1.5 rounded-full bg-terra" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};
